const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobPost(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.77,
    y: 378.66,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.31,
    y: 105.24,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.32,404c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45V404l0-11.19v-.5h.5l17.58.07c4.37,0,13.2.13,17.58.19h.24v.24L78.32,404Zm0,0-.24-11.19.24.24c-4.39.06-13.2.15-17.58.19l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.11,231c-5.85.1-20.62.35-26.29.41l-8.86,0h-.46V231l0-11.19v-.5H417l17.57.07c4.38,0,13.21.13,17.58.19h.25v.24L452.11,231Zm0,0-.23-11.19.23.24c-4.38.06-13.19.15-17.58.19l-17.57.07.5-.5,0,11.19-.45-.46,8.71,0c5.57.06,20.68.31,26.44.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.5,245.06c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.46l-.05-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.24c-4.38.06-13.19.15-17.58.19l-17.58.07.5-.5,0,11.19-.46-.46,8.71.05c5.58.06,20.69.31,26.45.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.81,
    y: 219.76,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.68,
    y: 392.77,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 47.22,
    width: 35.16,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.84,72.52c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.45l-.05-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.23c-4.39.07-13.19.16-17.58.2l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.58.07,20.69.32,26.45.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.93,58.41c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.46l0-11.19v-.5h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.24,11.19Zm0,0-.24-11.19.24.23c-4.39.07-13.2.16-17.58.2l-17.58.07.5-.5,0,11.19L62.77,58l8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.67,429.7c-5.86.1-20.63.35-26.29.41l-8.87,0h-.45v-.46l0-11.19V418h.5l17.58.07c4.38,0,13.2.13,17.58.19h.24v.24l-.23,11.19Zm0,0-.24-11.19.24.24c-4.39.06-13.2.15-17.58.19l-17.58.07.5-.5,0,11.19-.46-.46,8.71,0c5.57.07,20.68.32,26.45.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.97,
    y: 329.29,
    width: 91.77,
    height: 127,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.53,
    y: 324.58,
    width: 100.66,
    height: 4.71,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 431.19,
    y: 324.58,
    width: 31.66,
    height: 4.71,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.74,
    y: 329.29,
    width: 31.09,
    height: 127,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,388.08h-72V347.36h72Zm-71.78-.25h71.53V347.61H345.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.81,
    y: 359.26,
    width: 14.02,
    height: 8.06,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.09,366.84H374.83v-7.09h14.26Zm-14-.25h13.76V360H375.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.87,439.21h-72V398.49h72ZM345.09,439h71.53V398.74H345.09Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.81,
    y: 410.39,
    width: 14.02,
    height: 8.06,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.09,418H374.83v-7.09h14.26Zm-14-.25h13.76v-6.59H375.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.56,
    y: -0.6,
    width: 0.71,
    height: 97.75,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 125.53 92.99 130.74 38.83 130.74 36.47 125.53 59.53 109.57 72.3 109.57 95.36 125.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.9 94.2 72.3 109.57 59.53 109.57 57.93 94.2 73.9 94.2",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.36 125.53 92.99 130.74 38.83 130.74 36.47 125.53 95.36 125.53",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.78,
    y: -0.6,
    width: 0.71,
    height: 70.96,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.58 98.74 156.21 103.94 102.06 103.94 99.69 98.74 122.75 82.78 135.53 82.78 158.58 98.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.13 67.4 135.53 82.78 122.75 82.78 121.15 67.4 137.13 67.4",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.58 98.74 156.21 103.94 102.05 103.94 99.69 98.74 158.58 98.74",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-78"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "44.45 465.04 95.84 464.8 147.23 464.71 250 464.54 352.77 464.71 404.16 464.8 455.55 465.04 404.16 465.29 352.77 465.37 250 465.54 147.23 465.37 95.84 465.28 44.45 465.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.43,
    y: 125.78,
    width: 407.13,
    height: 272.39,
    rx: 12.89,
    transform: "translate(511.97 11.97) rotate(90)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.61,
    y: 86.9,
    width: 249.09,
    height: 350.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.88,
    y: 45.31,
    width: 4.23,
    height: 59.28,
    rx: 1.25,
    transform: "translate(324.94 -175.05) rotate(90)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 451.06,
    r: 7.67,
    transform: "translate(-248.02 584.97) rotate(-76.05)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.61,
    y: 86.9,
    width: 249.09,
    height: 350.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.61,
    y: 86.9,
    width: 249.09,
    height: 8.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.27,91.18a1.8,1.8,0,1,1-1.79-1.79A1.8,1.8,0,0,1,133.27,91.18Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,91.18a1.8,1.8,0,1,1-1.8-1.79A1.81,1.81,0,0,1,140.6,91.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.93,91.18a1.8,1.8,0,1,1-1.8-1.79A1.81,1.81,0,0,1,147.93,91.18Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.23 252.03 145.76 248.78 149.23 245.54 149.74 246.09 146.86 248.78 149.74 251.48 149.23 252.03",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.51,254.57a5.79,5.79,0,1,1,5.78-5.79A5.79,5.79,0,0,1,148.51,254.57Zm0-10.57a4.79,4.79,0,1,0,4.78,4.78A4.79,4.79,0,0,0,148.51,244Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.77 252.03 350.26 251.48 353.14 248.78 350.26 246.09 350.77 245.54 354.24 248.78 350.77 252.03",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.49,254.57a5.79,5.79,0,1,1,5.78-5.79A5.79,5.79,0,0,1,351.49,254.57Zm0-10.57a4.79,4.79,0,1,0,4.78,4.78A4.79,4.79,0,0,0,351.49,244Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L292.46,272h-26Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.29,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L292.46,272h-26Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.24,302.82h-56L259,267.43h33Zm-51.16-4.59h43.06L289.4,272h-26Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.24,302.82h-56L259,267.43h33Zm-51.16-4.59h43.06L289.4,272h-26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.05,
    y: 303.71,
    width: 7.66,
    height: 15.93,
    transform: "translate(497.75 623.34) rotate(180)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.95,
    y: 319.63,
    width: 13.85,
    height: 38.31,
    transform: "translate(497.75 677.58) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.8,
    y: 336.45,
    width: 6.09,
    height: 2.57,
    transform: "translate(517.69 675.47) rotate(180)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.89,
    y: 335.09,
    width: 12.38,
    height: 5.28,
    transform: "translate(536.16 675.47) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.17,
    y: 357.94,
    width: 17.85,
    height: 16.1,
    transform: "translate(498.18 731.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.07 388.06 250.79 388.06 252.87 364.99 244.98 364.99 247.07 388.06",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.73 381.97 301.04 379.43 258.02 362.6 258.02 374.05 297.73 381.97",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200.46 381.97 197.15 379.43 240.16 362.6 240.16 374.05 200.46 381.97",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.95,
    y: 353.72,
    width: 13.85,
    height: 4.22,
    transform: "translate(497.75 711.66) rotate(180)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.87,
    cy: 387.57,
    r: 9.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.62,387.57a4.26,4.26,0,1,0,4.25-4.25A4.25,4.25,0,0,0,293.62,387.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.27,
    cy: 387.57,
    r: 9.04,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,387.57a4.26,4.26,0,1,0,4.26-4.25A4.25,4.25,0,0,0,196,387.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.2,
    y: 385.24,
    width: 5.67,
    height: 14.88,
    transform: "translate(498.07 785.37) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192 303.71 316.97 303.71 316.97 294.21 270.19 294.21 254.46 199.07 196.77 199.07 192 303.71",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.19 294.21 200.52 294.21 204.68 199.07 254.46 199.07 270.19 294.21",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.17,
    y: 294.21,
    width: 72.8,
    height: 9.5,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L225.57,272h-26Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.41,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L225.57,272h-26Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L222.52,272h-26Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.35,302.82h-56l1.75-35.39h33Zm-51.15-4.59h43.05L222.52,272h-26Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.49,
    y: 230.57,
    width: 77.33,
    height: 26.78,
    transform: "translate(-41.79 47.45) rotate(-10.84)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.08,253.46l-.12-.05s0,0,0,0a.36.36,0,0,1-.09-.08s0,0,0,0a.32.32,0,0,0-.1-.1l-5.29-8a.8.8,0,0,1,.24-1.14.82.82,0,0,1,1.14.23l4.21,6.31,1.57-7.42a.84.84,0,0,1,1.64.34l-2,9.36a.38.38,0,0,1,0,.13s0,0,0,0-.05.07-.06.1,0,0,0,.05a.71.71,0,0,1-.07.09l0,0s-.06.08-.1.1,0,0,0,0l-.11.05h0l-.15,0a.37.37,0,0,1-.15,0h-.19l-.15-.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.67,249.05l-3.6.69-.36,2.07a.86.86,0,0,1-.67.67,1,1,0,0,1-.29,0,.86.86,0,0,1-.69-1l1.6-9.36a.85.85,0,0,1,.69-.67.82.82,0,0,1,.88.37l5,8.1a.86.86,0,0,1-.28,1.17,1,1,0,0,1-.27.09.81.81,0,0,1-.86-.37Zm-.92-1.51-1.81-3-.59,3.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.35,245.54a5.55,5.55,0,0,1,4.43-6.38,5.61,5.61,0,0,1,3.64.5.87.87,0,0,1-.78,1.55,3.72,3.72,0,0,0-2.54-.36,4,4,0,0,0-2.47,1.58,3.7,3.7,0,0,0,1,5.16,4,4,0,0,0,2.88.56,3.79,3.79,0,0,0,2.23-1.28.93.93,0,0,1,1.22-.06A.9.9,0,0,1,228,248a5.65,5.65,0,0,1-3.21,1.82A5.53,5.53,0,0,1,218.35,245.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.88,245.18l-3.61.69-.36,2.07a.84.84,0,0,1-.67.67.94.94,0,0,1-.29,0,.86.86,0,0,1-.69-1l1.6-9.36a.85.85,0,0,1,.69-.67.84.84,0,0,1,.89.37l4.95,8.11a.86.86,0,0,1-.29,1.16,1,1,0,0,1-.27.1A.81.81,0,0,1,237,247Zm-.92-1.51-1.82-3-.59,3.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.11,245.68a.84.84,0,0,1-.65,1,.82.82,0,0,1-1-.66l-1.65-8.62h0a.81.81,0,0,1,.19-.75.83.83,0,0,1,1.16,0l6.06,5.71-1.17-6.11a.82.82,0,0,1,1.62-.31l1.65,8.62a.83.83,0,0,1-.66,1,.82.82,0,0,1-.66-.18.36.36,0,0,1-.09-.08l-6-5.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,234.7l-2.35.45,1.51,7.92a.82.82,0,0,1-.66,1,.83.83,0,0,1-1-.66l-1.52-7.92-2.34.45a.84.84,0,0,1-.31-1.65l6.33-1.21a.83.83,0,0,1,1,.66A.85.85,0,0,1,256.59,234.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62,223.54q-6.44-2.65-12.73-5.58c-4.21-1.93-8.38-3.94-12.54-6s-8.29-4.12-12.39-6.27-8.18-4.35-12.21-6.65q6.44,2.66,12.73,5.58c4.21,1.93,8.38,3.94,12.54,6s8.29,4.12,12.39,6.27S260.59,221.24,264.62,223.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.69,222.71c-.91,2.7-2,5.3-3.18,7.87a84,84,0,0,1-3.84,7.5,82.69,82.69,0,0,1,3.17-7.86C193,227.66,194.26,225.13,195.69,222.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.85,396.62c59-.66,125.27-.66,184.3,0-59,.65-125.27.65-184.3,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.06,127.06l-9.26,22.06a1.25,1.25,0,0,1-.19.34l0,0a.93.93,0,0,1-.19.22c0,.08,0,.08,0,.12a.86.86,0,0,0-.26.19h0a1.17,1.17,0,0,1-.34.22h0a0,0,0,0,0,0,0,1.12,1.12,0,0,0-.3.08h-.08a1.38,1.38,0,0,1-.37,0,1.27,1.27,0,0,1-.34,0h-.12a.92.92,0,0,0-.26-.08s0,0-.08,0a.87.87,0,0,1-.34-.22h0a2,2,0,0,0-.26-.19.31.31,0,0,1-.08-.12c0-.07-.11-.15-.15-.22s-.07,0-.07,0a.81.81,0,0,1-.15-.34l-5-11.73-5,11.73a2.16,2.16,0,0,1-.15.34s0,0,0,0l-.23.22c0,.08,0,.08,0,.12a.77.77,0,0,0-.23.19h-.07c-.12.07-.23.18-.3.22h0a0,0,0,0,0,0,0,.54.54,0,0,0-.3.08h-.12a1.27,1.27,0,0,1-.34,0,1.67,1.67,0,0,1-.38,0h-.11a.92.92,0,0,0-.26-.08s0,0-.08,0A1.33,1.33,0,0,1,174,150h0c-.11-.08-.15-.16-.26-.19a.31.31,0,0,1-.08-.12c-.07-.07-.11-.15-.19-.22v0c-.07-.08-.11-.23-.19-.34l-9.3-22.06a2.07,2.07,0,0,1,3.82-1.58L175.17,143l4.88-11.61a2.08,2.08,0,0,1,2-1.29,2.16,2.16,0,0,1,2,1.29L188.87,143l7.37-17.51a2.11,2.11,0,0,1,2.76-1.1A2,2,0,0,1,200.06,127.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.67,141a9.37,9.37,0,0,1,9.23-9.46,9.06,9.06,0,0,1,9.12,8.78v.19a1,1,0,0,1,0,.34,1.83,1.83,0,0,1-2,1.51H207a5,5,0,0,0,1.29,2.5,5.92,5.92,0,0,0,3.63,1.7,6.18,6.18,0,0,0,3.93-.95,2.14,2.14,0,0,1,2.84-.11,1.73,1.73,0,0,1,0,2.46,9.55,9.55,0,0,1-6.77,2.49A9.38,9.38,0,0,1,202.67,141Zm4.12-1.86H217.5a6.2,6.2,0,0,0-5.6-4A5.3,5.3,0,0,0,206.79,139.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.37,141v7.42a2,2,0,0,1-2,2,2.07,2.07,0,0,1-2-1.62,8.6,8.6,0,0,1-5,1.62,8.8,8.8,0,0,1-6.43-2.76,9.66,9.66,0,0,1-2.57-6.66,9.51,9.51,0,0,1,2.57-6.65,8.72,8.72,0,0,1,6.43-2.84,8.63,8.63,0,0,1,5,1.66,2.07,2.07,0,0,1,2-1.66,2,2,0,0,1,2,2Zm-4,0a5.54,5.54,0,0,0-1.47-3.89,4.68,4.68,0,0,0-3.52-1.55,4.57,4.57,0,0,0-3.52,1.55,5.56,5.56,0,0,0-1.43,3.89,5.69,5.69,0,0,0,1.43,3.9,4.76,4.76,0,0,0,3.52,1.48,4.87,4.87,0,0,0,3.52-1.48A5.67,5.67,0,0,0,250.36,141Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.44,133.49a2,2,0,0,1-2,2,3.62,3.62,0,0,0-2.27.72,5.78,5.78,0,0,0-1.74,1.81,11.55,11.55,0,0,0-1.55,3.18v7.19a2.06,2.06,0,0,1-2.08,2,2,2,0,0,1-2-2V133.49a2,2,0,0,1,2-2,2,2,0,0,1,2.08,2v.27a4.76,4.76,0,0,1,.8-.76,8.25,8.25,0,0,1,4.76-1.47A2,2,0,0,1,273.44,133.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18,141a9.35,9.35,0,0,1,9.23-9.46,9,9,0,0,1,9.11,8.78v.19a1,1,0,0,1,0,.34,1.82,1.82,0,0,1-2,1.51h-12a5,5,0,0,0,1.28,2.5,6,6,0,0,0,3.64,1.7,6.2,6.2,0,0,0,3.93-.95,2.14,2.14,0,0,1,2.84-.11,1.73,1.73,0,0,1,0,2.46,9.58,9.58,0,0,1-6.77,2.49A9.37,9.37,0,0,1,275.18,141Zm4.12-1.86H290a6.19,6.19,0,0,0-5.59-4A5.29,5.29,0,0,0,279.3,139.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.9,180.11a2.09,2.09,0,0,1-2.12,2.08,2.15,2.15,0,0,1-2-1.55,2.26,2.26,0,0,1-.07-.53V157.79a2.1,2.1,0,0,1,4.2,0v6.58a8.65,8.65,0,0,1,4-1.1,8.28,8.28,0,0,1,8.25,8.29v8.55a2.08,2.08,0,1,1-4.16,0v-8.55a4.07,4.07,0,1,0-8.13,0Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,158.54a2,2,0,0,1-2,2.08,2.06,2.06,0,0,1-2-2.08v-.79a2,2,0,0,1,2-2,2,2,0,0,1,2,2Zm0,6.85v14.75a2,2,0,0,1-2,2.05,2,2,0,0,1-2-2.05V165.39a2,2,0,0,1,2-2.08A2,2,0,0,1,224,165.39Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.16,165.28a2,2,0,0,1-2,2,3.62,3.62,0,0,0-2.27.72,5.61,5.61,0,0,0-1.74,1.82,11.64,11.64,0,0,0-1.56,3.17v7.19a2.06,2.06,0,0,1-2.08,2,2,2,0,0,1-2-2v-14.9a2,2,0,0,1,2-2,2,2,0,0,1,2.08,2v.26a5.12,5.12,0,0,1,.8-.75,8.22,8.22,0,0,1,4.77-1.48A2,2,0,0,1,242.16,165.28Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.24,158.54a2,2,0,0,1-2.05,2.08,2.06,2.06,0,0,1-2-2.08v-.79a2,2,0,0,1,2-2,2,2,0,0,1,2.05,2Zm0,6.85v14.75a2,2,0,0,1-2.05,2.05,2,2,0,0,1-2-2.05V165.39a2,2,0,0,1,2-2.08A2,2,0,0,1,251.24,165.39Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.52,171.14v9a2,2,0,0,1-2,2,2,2,0,0,1-2-2v-9a3.88,3.88,0,0,0-3.93-3.82,3.77,3.77,0,0,0-3.78,3.82v9a.72.72,0,0,1-.08.38,2.07,2.07,0,0,1-2,1.63,2,2,0,0,1-2-2v-14.9a2,2,0,0,1,2-2,2,2,0,0,1,1.85,1.18,7.52,7.52,0,0,1,4-1.18A7.93,7.93,0,0,1,273.52,171.14Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.84,172.84v7a9.11,9.11,0,0,1-9.08,9.08,8.71,8.71,0,0,1-4-1,2,2,0,0,1-.91-2.72,2.05,2.05,0,0,1,2.72-.95,4.54,4.54,0,0,0,2.16.53,5.06,5.06,0,0,0,4.95-4.05,8.7,8.7,0,0,1-11.38-1.36,9.44,9.44,0,0,1-2.65-6.65,9.92,9.92,0,0,1,2.65-6.74,8.94,8.94,0,0,1,6.43-2.8,8.66,8.66,0,0,1,5.07,1.59,2,2,0,0,1,2-1.59,2,2,0,0,1,2,2v7.56Zm-4,0a5.86,5.86,0,0,0-1.44-3.86,4.72,4.72,0,0,0-3.59-1.63,4.52,4.52,0,0,0-3.48,1.63,5.53,5.53,0,0,0-1.52,3.86,5.45,5.45,0,0,0,1.52,3.89,4.58,4.58,0,0,0,3.48,1.55,4.78,4.78,0,0,0,3.59-1.55A5.76,5.76,0,0,0,293.79,172.81Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.33,166.7V136.79a4.11,4.11,0,0,1,4.07-4.08,4,4,0,0,1,4,4.08V166.7a4,4,0,0,1-4,4.08A4.06,4.06,0,0,1,308.33,166.7Zm4.07,17.85a4.06,4.06,0,0,1-4.07-4.07V179a4.11,4.11,0,0,1,4.07-4.08,4,4,0,0,1,4,4.08v1.48A4,4,0,0,1,312.4,184.55Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.7,
    y: 410.86,
    width: 58.6,
    height: 15.18,
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.79,420.9a.46.46,0,0,1-.44.45.45.45,0,0,1-.44-.45v-4.68h0a.43.43,0,0,1,.17-.37.44.44,0,0,1,.62.1l2.6,3.6v-3.32a.44.44,0,0,1,.44-.44.45.45,0,0,1,.44.44v4.68a.43.43,0,0,1-.77.29l-.05-.05-2.57-3.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.16,416.4a3,3,0,0,1,.81,2,2.93,2.93,0,0,1-.81,2,2.64,2.64,0,0,1-1.93.87,2.7,2.7,0,0,1-2-.87,2.92,2.92,0,0,1-.8-2,3,3,0,0,1,.8-2,2.69,2.69,0,0,1,2-.86A2.63,2.63,0,0,1,263.16,416.4Zm-.11,2a2.11,2.11,0,0,0-.54-1.41,1.77,1.77,0,0,0-1.28-.57,1.75,1.75,0,0,0-1.3.57,2.07,2.07,0,0,0-.55,1.41,2,2,0,0,0,.55,1.41,1.76,1.76,0,0,0,1.3.58,1.78,1.78,0,0,0,1.28-.58A2.07,2.07,0,0,0,263.05,418.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.71,416.37l-2,4.7s0,.06,0,.07h0a.07.07,0,0,1,0,.05s0,0,0,0a.09.09,0,0,0-.05,0h0s0,0-.07,0h0l-.06,0h-.2l-.05,0h0a.12.12,0,0,1-.07,0h0s0,0-.06,0v0a.09.09,0,0,1,0-.05h0s0,0,0-.07l-1.06-2.5-1.05,2.5a.21.21,0,0,1,0,.07h0l0,.05s0,0,0,0,0,0,0,0h0s0,0-.06,0h0l-.06,0h-.2l-.06,0h0s-.06,0-.08,0h0s0,0-.05,0l0,0,0-.05h0s0,0,0-.07l-2-4.7a.44.44,0,0,1,.24-.57.43.43,0,0,1,.57.23l1.58,3.74,1-2.48a.43.43,0,0,1,.42-.27.45.45,0,0,1,.42.27l1,2.48,1.57-3.74a.45.45,0,0,1,.59-.23A.44.44,0,0,1,272.71,416.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.45,420h-1.94l-.39,1a.47.47,0,0,1-.42.28l-.15,0a.46.46,0,0,1-.27-.58l1.77-4.72a.44.44,0,0,1,.43-.28.43.43,0,0,1,.42.28l1.77,4.72a.46.46,0,0,1-.26.58l-.15,0a.43.43,0,0,1-.41-.28Zm-.32-.88-.65-1.73-.65,1.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.64,419.18h-1v1.74a.45.45,0,0,1-.89,0v-4.73a.44.44,0,0,1,.44-.44h1.43a1.72,1.72,0,1,1,0,3.43Zm-1-.89h1a.83.83,0,1,0,0-1.65h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.31,419.18h-1v1.74a.44.44,0,0,1-.44.44.45.45,0,0,1-.45-.44v-4.73a.45.45,0,0,1,.45-.44h1.43a1.72,1.72,0,1,1,0,3.43Zm-1-.89h1a.83.83,0,1,0,0-1.65h-1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,420.92v-4.73a.44.44,0,0,1,.44-.44.45.45,0,0,1,.45.44v4.28h2.17a.45.45,0,0,1,0,.89h-2.62A.44.44,0,0,1,242.1,420.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.47,416.5l-1.64,2.26v2.16a.43.43,0,0,1-.44.44.44.44,0,0,1-.44-.44v-2.16l-1.63-2.26a.41.41,0,0,1,.09-.6.42.42,0,0,1,.61.09l1.37,1.88,1.37-1.88a.43.43,0,0,1,.61-.09A.43.43,0,0,1,249.47,416.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-2--inject-78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 326.46,
    y: 37.64,
    width: 129.09,
    height: 95.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.55,133.27l-129.29.2c-.17,0,.07-95.74-.05-95.83v-.25h.25c.09,0,129.14.13,129.24.1s-.24,95.66-.15,95.78Zm0,0c0,.06-.35-96.29,0-95.48l-129.09.1.25-.25c0-.07.2,96.51-.25,95.43l129.09.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.46,
    y: 37.64,
    width: 129.09,
    height: 8.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.11,41.92a1.79,1.79,0,1,1-1.79-1.79A1.79,1.79,0,0,1,334.11,41.92Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.44,41.92a1.8,1.8,0,1,1-1.79-1.79A1.79,1.79,0,0,1,341.44,41.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.77,41.92A1.8,1.8,0,1,1,347,40.13,1.79,1.79,0,0,1,348.77,41.92Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.06,86.41a2.37,2.37,0,0,0,4.61-.72V78.88a1,1,0,0,1,1.91,0v6.81a4.26,4.26,0,0,1-8.32,1.3.95.95,0,0,1,1.8-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.79,79.43a6.3,6.3,0,0,1,0,8.67,5.59,5.59,0,0,1-4.09,1.84,5.75,5.75,0,0,1-4.2-1.84,6.38,6.38,0,0,1,0-8.67,5.71,5.71,0,0,1,4.2-1.83A5.55,5.55,0,0,1,364.79,79.43Zm-.22,4.34a4.43,4.43,0,0,0-1.16-3,3.7,3.7,0,0,0-5.49,0,4.34,4.34,0,0,0-1.16,3,4.29,4.29,0,0,0,1.16,3,3.68,3.68,0,0,0,5.49,0A4.38,4.38,0,0,0,364.57,83.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,89V78.88a.94.94,0,0,1,.95-.94h2.43a3.26,3.26,0,0,1,2.6,5.21,3.67,3.67,0,0,1-1.93,6.79h-3s0,0,0,0,0,0-.05,0A1,1,0,0,1,369.3,89Zm1.91-6.41h1.47A1.37,1.37,0,0,0,374,81.2a1.35,1.35,0,0,0-1.35-1.36h-1.47Zm0,5.45h2.14a1.77,1.77,0,0,0,0-3.54h-2.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.08,79.43a6.3,6.3,0,0,1,0,8.67A5.59,5.59,0,0,1,390,89.94a5.75,5.75,0,0,1-4.2-1.84,6.38,6.38,0,0,1,0-8.67A5.71,5.71,0,0,1,390,77.6,5.55,5.55,0,0,1,394.08,79.43Zm-.22,4.34a4.39,4.39,0,0,0-1.17-3,3.7,3.7,0,0,0-2.7-1.22,3.74,3.74,0,0,0-2.78,1.22,4.35,4.35,0,0,0-1.17,3,4.3,4.3,0,0,0,1.17,3A3.75,3.75,0,0,0,390,88a3.71,3.71,0,0,0,2.7-1.23A4.34,4.34,0,0,0,393.86,83.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,89V78.88a.94.94,0,0,1,.94-.94h5.61a1,1,0,0,1,0,1.9h-4.65V83h4a1,1,0,1,1,0,1.9h-4V89a1,1,0,0,1-1,1A.94.94,0,0,1,399.19,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.56,89V78.88a.94.94,0,0,1,.94-.94h5.6a1,1,0,1,1,0,1.9h-4.64V83h4a1,1,0,1,1,0,1.9h-4V89a1,1,0,0,1-1,1A.94.94,0,0,1,409.56,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.93,89V78.88a.93.93,0,0,1,.94-.94h5.6a1,1,0,0,1,.95.94,1,1,0,0,1-.95,1h-4.64V83h4a1,1,0,0,1,0,1.9h-4V88h4.64a1,1,0,0,1,0,1.91h-5.55s0,0,0,0l0,0A.94.94,0,0,1,419.93,89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.37,88.51a1,1,0,0,1-.6,1.2,1.44,1.44,0,0,1-.38.05h0a1.27,1.27,0,0,1-.67-.18,1.65,1.65,0,0,1-.54-.6,4.64,4.64,0,0,1-.36-2.06,1.48,1.48,0,0,0-.21-.74,1.5,1.5,0,0,0-.51-.49,3.57,3.57,0,0,0-1-.42h-2V89a1,1,0,0,1-1,1,.94.94,0,0,1-.94-1V78.88a.93.93,0,0,1,.94-.94h3.07a3.67,3.67,0,0,1,3.67,3.68,3.62,3.62,0,0,1-1.34,2.82,2.41,2.41,0,0,1,.6.63,3.2,3.2,0,0,1,.57,1.85,3.86,3.86,0,0,0,.07,1A1,1,0,0,1,438.37,88.51ZM436,81.62a1.77,1.77,0,0,0-1.77-1.78h-2.11v3.53h2.11A1.76,1.76,0,0,0,436,81.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.04,
    y: 107.78,
    width: 47.92,
    height: 12.41,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.1,116a.36.36,0,0,1-.36.36.36.36,0,0,1-.36-.36v-3.83h0a.36.36,0,0,1,.14-.3.38.38,0,0,1,.51.08l2.12,2.95v-2.72a.36.36,0,1,1,.72,0V116a.36.36,0,0,1-.36.36.37.37,0,0,1-.27-.13s0,0,0,0l-2.11-2.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.76,112.31a2.42,2.42,0,0,1,0,3.34,2.15,2.15,0,0,1-1.57.7,2.21,2.21,0,0,1-1.62-.7,2.47,2.47,0,0,1,0-3.34,2.21,2.21,0,0,1,1.62-.7A2.15,2.15,0,0,1,401.76,112.31Zm-.08,1.67a1.7,1.7,0,0,0-.45-1.15,1.42,1.42,0,0,0-1-.47,1.44,1.44,0,0,0-1.07.47,1.69,1.69,0,0,0,0,2.3,1.42,1.42,0,0,0,2.11,0A1.7,1.7,0,0,0,401.68,114Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57,112.29,408,116.13s0,.05,0,.06h0l0,0v0a.1.1,0,0,0-.05,0h0s0,0-.06,0h0l-.05,0h-.16l-.05,0h0a.15.15,0,0,1-.06,0h0l-.05,0s0,0,0,0l0,0a0,0,0,0,1,0,0s0,0,0-.06l-.86-2-.87,2s0,.05,0,.06a0,0,0,0,0,0,0l0,0s0,0,0,0l0,0h0l-.05,0h0l-.05,0h-.16l0,0h0l-.06,0h0s0,0,0,0l0,0,0,0h0l0-.06-1.62-3.84a.35.35,0,0,1,.19-.47.36.36,0,0,1,.47.19l1.29,3,.85-2a.37.37,0,0,1,.35-.23.38.38,0,0,1,.34.23l.85,2,1.28-3a.38.38,0,0,1,.49-.19A.36.36,0,0,1,409.57,112.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,115.28h-1.59l-.32.85a.36.36,0,0,1-.34.23.27.27,0,0,1-.13,0,.36.36,0,0,1-.21-.47l1.44-3.86a.39.39,0,0,1,.35-.23.38.38,0,0,1,.35.23l1.45,3.86a.38.38,0,0,1-.22.47.23.23,0,0,1-.12,0,.35.35,0,0,1-.34-.23Zm-.27-.72-.53-1.41-.53,1.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.44,114.58h-.8V116a.37.37,0,0,1-.37.36.36.36,0,0,1-.36-.36v-3.86a.36.36,0,0,1,.36-.36h1.17a1.4,1.4,0,1,1,0,2.8Zm-.8-.72h.8a.68.68,0,1,0,0-1.35h-.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.26,114.58h-.81V116a.36.36,0,1,1-.72,0v-3.86a.36.36,0,0,1,.36-.36h1.17a1.4,1.4,0,1,1,0,2.8Zm-.81-.72h.81a.68.68,0,1,0,0-1.35h-.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.54,116v-3.86a.37.37,0,0,1,.73,0v3.5h1.78a.36.36,0,0,1,0,.72h-2.14A.36.36,0,0,1,384.54,116Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.57,112.39l-1.34,1.84V116a.35.35,0,0,1-.36.36.36.36,0,0,1-.36-.36v-1.77l-1.33-1.84a.33.33,0,0,1,.07-.49.35.35,0,0,1,.5.07l1.12,1.54L390,112a.36.36,0,0,1,.58.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window-1--inject-78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44.45,
    y: 255.68,
    width: 129.09,
    height: 95.63,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.54,351.31l-129.29.2c-.16,0,.07-95.75,0-95.83v-.25h.25c.1-.05,129.15.13,129.24.09s-.24,95.67-.15,95.79Zm0,0c0,.05-.34-96.29,0-95.48l-129.09.1.25-.25c0-.08.2,96.51-.24,95.42l129.08.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.45,
    y: 255.68,
    width: 129.09,
    height: 8.56,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.11,260a1.8,1.8,0,1,1-1.8-1.8A1.79,1.79,0,0,1,52.11,260Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.44,260a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,59.44,260Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.77,260a1.8,1.8,0,1,1-1.8-1.8A1.8,1.8,0,0,1,66.77,260Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.93,290.26a3,3,0,0,0,5.88-.92v-8.67a1.21,1.21,0,0,1,2.42,0v8.67A5.43,5.43,0,0,1,65.64,291a1.2,1.2,0,0,1,2.29-.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.51,293.16a5.47,5.47,0,0,1-1.5-3.84,5.64,5.64,0,0,1,1.5-3.82,5.1,5.1,0,0,1,3.76-1.66,4.83,4.83,0,0,1,3.65,1.66,5.43,5.43,0,0,1,1.52,3.82,5.28,5.28,0,0,1-1.52,3.84,4.83,4.83,0,0,1-3.65,1.66A5.1,5.1,0,0,1,80.51,293.16Zm.88-3.84a3.52,3.52,0,0,0,.78,2.31,3,3,0,0,0,2.1.81,2.85,2.85,0,0,0,2-.81,3.37,3.37,0,0,0,.85-2.31,3.3,3.3,0,0,0-.85-2.27,3.11,3.11,0,0,0-2-.83,3.19,3.19,0,0,0-2.1.83A3.45,3.45,0,0,0,81.39,289.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,281.11a1.18,1.18,0,0,1-1.18,1.2,1.2,1.2,0,0,1-1.18-1.2v-.46a1.18,1.18,0,0,1,1.18-1.18,1.16,1.16,0,0,1,1.18,1.18Zm0,3.95v8.52a1.16,1.16,0,0,1-1.18,1.17,1.17,1.17,0,0,1-1.18-1.17v-8.52a1.17,1.17,0,0,1,1.18-1.2A1.15,1.15,0,0,1,95.54,285.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.4,288.38v5.22a1.14,1.14,0,0,1-1.13,1.15,1.18,1.18,0,0,1-1.16-1.15v-5.22a2.24,2.24,0,0,0-2.27-2.21,2.19,2.19,0,0,0-2.18,2.21v5.22a.4.4,0,0,1,0,.22,1.19,1.19,0,0,1-1.15.93,1.15,1.15,0,0,1-1.16-1.15V285a1.15,1.15,0,0,1,1.16-1.15,1.2,1.2,0,0,1,1.07.67,4.37,4.37,0,0,1,2.31-.67A4.57,4.57,0,0,1,108.4,288.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24,293.16a5.47,5.47,0,0,1-1.5-3.84,5.64,5.64,0,0,1,1.5-3.82,5.1,5.1,0,0,1,3.76-1.66,4.83,4.83,0,0,1,3.65,1.66,5.44,5.44,0,0,1,1.53,3.82,5.29,5.29,0,0,1-1.53,3.84,4.83,4.83,0,0,1-3.65,1.66A5.1,5.1,0,0,1,120.24,293.16Zm.88-3.84a3.52,3.52,0,0,0,.78,2.31,3,3,0,0,0,2.1.81,2.85,2.85,0,0,0,2-.81,3.32,3.32,0,0,0,.85-2.31,3.25,3.25,0,0,0-.85-2.27,3.11,3.11,0,0,0-2-.83,3.19,3.19,0,0,0-2.1.83A3.45,3.45,0,0,0,121.12,289.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.87,294.75a4.57,4.57,0,0,1-4.55-4.54V285a1.18,1.18,0,0,1,1.16-1.15,1.16,1.16,0,0,1,1.16,1.15v5.22a2.21,2.21,0,0,0,2.23,2.23,2.26,2.26,0,0,0,2.29-2.23V285a1.14,1.14,0,0,1,1.13-1.15,1.2,1.2,0,0,1,1.18,1.15v5.22A4.6,4.6,0,0,1,136.87,294.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.66,285a1.17,1.17,0,0,1-1.16,1.16,2.06,2.06,0,0,0-1.31.42,3.21,3.21,0,0,0-1,1,6.57,6.57,0,0,0-.9,1.84v4.15a1.19,1.19,0,0,1-1.2,1.15,1.17,1.17,0,0,1-1.16-1.15V285a1.15,1.15,0,0,1,1.16-1.13,1.17,1.17,0,0,1,1.2,1.13v.16a2.71,2.71,0,0,1,.46-.44,4.8,4.8,0,0,1,2.75-.85A1.14,1.14,0,0,1,152.66,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.21,305.16A1.24,1.24,0,0,1,87,306.37h-.55v6.09a1.2,1.2,0,0,1,1.2,1.22,1.18,1.18,0,0,1-1.2,1.2A2.43,2.43,0,0,1,84,312.46v-6.09h-.63a1.2,1.2,0,0,1-1.2-1.21,1.18,1.18,0,0,1,1.2-1.2H84V300.8a1.2,1.2,0,0,1,1.22-1.2,1.18,1.18,0,0,1,1.2,1.2V304H87A1.22,1.22,0,0,1,88.21,305.16Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4,309.42A5.4,5.4,0,0,1,95.73,304,5.23,5.23,0,0,1,101,309v.11a.62.62,0,0,1,0,.19,1.06,1.06,0,0,1-1.14.88H92.89a2.89,2.89,0,0,0,.74,1.44,3.37,3.37,0,0,0,2.1,1,3.58,3.58,0,0,0,2.27-.54,1.23,1.23,0,0,1,1.63-.07,1,1,0,0,1,0,1.42,5.51,5.51,0,0,1-3.9,1.44A5.41,5.41,0,0,1,90.4,309.42Zm2.38-1.07H99A3.57,3.57,0,0,0,95.73,306,3,3,0,0,0,92.78,308.35Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.7,309.44v4.28a1.16,1.16,0,0,1-1.16,1.16,1.18,1.18,0,0,1-1.13-.94,5,5,0,0,1-2.91.94,5.08,5.08,0,0,1-3.71-1.59,5.6,5.6,0,0,1-1.48-3.85,5.5,5.5,0,0,1,1.48-3.84A5.05,5.05,0,0,1,108.5,304a5,5,0,0,1,2.91,1,1.19,1.19,0,0,1,1.13-1,1.17,1.17,0,0,1,1.16,1.18Zm-2.31,0a3.17,3.17,0,0,0-.86-2.24,2.69,2.69,0,0,0-2-.9,2.65,2.65,0,0,0-2,.9,3.19,3.19,0,0,0-.83,2.24,3.29,3.29,0,0,0,.83,2.25,2.75,2.75,0,0,0,2,.85,2.79,2.79,0,0,0,2-.85A3.27,3.27,0,0,0,111.39,309.44Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11,308.48v5.24a1.16,1.16,0,0,1-1.16,1.16,1.2,1.2,0,0,1-1.18-1.16v-5.24a2.23,2.23,0,0,0-4.45.07v5.17s0,.11,0,.16v.06c0,.05,0,.09-.07.13v.11a1.25,1.25,0,0,1-1.09.7l-.22,0a1.2,1.2,0,0,1-.94-1.14v-8.58a1.17,1.17,0,0,1,1.16-1.18,1.1,1.1,0,0,1,1,.66,4.57,4.57,0,0,1,5.76.85,4.51,4.51,0,0,1,3.43-1.51,4.57,4.57,0,0,1,4.54,4.59v5.17a1.16,1.16,0,0,1-1.15,1.16,1.18,1.18,0,0,1-1.18-1.16v-5.17a2.24,2.24,0,0,0-2.21-2.25A2.27,2.27,0,0,0,127.11,308.48Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.04,
    y: 328.52,
    width: 47.92,
    height: 12.41,
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.29,335.74a.91.91,0,0,0,1.77-.27v-2.62a.36.36,0,0,1,.37-.36.35.35,0,0,1,.36.36v2.62a1.63,1.63,0,0,1-3.19.5.35.35,0,0,1,.23-.46A.36.36,0,0,1,92.29,335.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.49,333.06a2.42,2.42,0,0,1,0,3.34,2.19,2.19,0,0,1-1.57.7,2.25,2.25,0,0,1-1.62-.7,2.47,2.47,0,0,1,0-3.34,2.18,2.18,0,0,1,1.62-.71A2.12,2.12,0,0,1,99.49,333.06Zm-.08,1.67a1.72,1.72,0,0,0-.45-1.16,1.44,1.44,0,0,0-2.11,0,1.68,1.68,0,0,0-.45,1.16,1.61,1.61,0,0,0,.45,1.14,1.4,1.4,0,0,0,2.11,0A1.65,1.65,0,0,0,99.41,334.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.17,332.85a.35.35,0,0,1,.36-.36.36.36,0,0,1,.37.36v3.89a.37.37,0,0,1-.37.36.36.36,0,0,1-.36-.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.86,336.74a.36.36,0,0,1-.36.36.36.36,0,0,1-.36-.36v-3.83h0a.36.36,0,0,1,.14-.3.38.38,0,0,1,.51.08l2.13,2.94v-2.71a.36.36,0,0,1,.35-.36.36.36,0,0,1,.36.36v3.83a.36.36,0,0,1-.36.36A.37.37,0,0,1,106,337l0,0L103.86,334Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.91,336.74a.36.36,0,0,1-.35.36.35.35,0,0,1-.36-.36v-3.83h0a.34.34,0,0,1,.14-.3.36.36,0,0,1,.5.08l2.13,2.94v-2.71a.36.36,0,0,1,.36-.36.37.37,0,0,1,.36.36v3.83a.36.36,0,0,1-.36.36.34.34,0,0,1-.27-.13l0,0L110.91,334Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,333.06a2.44,2.44,0,0,1,0,3.34,2.19,2.19,0,0,1-1.58.7,2.24,2.24,0,0,1-1.61-.7,2.47,2.47,0,0,1,0-3.34,2.18,2.18,0,0,1,1.61-.71A2.13,2.13,0,0,1,118.58,333.06Zm-.09,1.67a1.72,1.72,0,0,0-.45-1.16,1.43,1.43,0,0,0-2.1,0,1.68,1.68,0,0,0-.45,1.16,1.61,1.61,0,0,0,.45,1.14,1.39,1.39,0,0,0,2.1,0A1.65,1.65,0,0,0,118.49,334.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.39,333l-1.62,3.85,0,.06h0s0,0,0,0v0l0,0h0s0,0-.06,0h-.28a.07.07,0,0,1-.06,0h0l0,0v0a.05.05,0,0,1,0,0h0a.14.14,0,0,1,0-.06l-.87-2.05-.86,2.05,0,.06h0l0,0v0l0,0h0s0,0-.06,0h-.29s0,0-.06,0h0l0,0v0l0,0h0s0,0,0-.06L120.09,333a.36.36,0,0,1,.67-.27l1.29,3.05.85-2a.37.37,0,0,1,.68,0l.86,2,1.28-3.05a.36.36,0,0,1,.48-.19A.35.35,0,0,1,126.39,333Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M310.87,341.13,279.73,366c-6.42,5.32-12,10.09-14.58,12.83l0,0a5.93,5.93,0,0,0-1.59,2.11s0,.05,0,.07c.29,3,41.29,55.53,43.33,56.88s6.06-4.38,6.1-7.69-6.67-30.45-6.67-30.45l29.94-26.08Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,437.9c-2-1.35-43-53.89-43.33-56.88,0,0,0,0,0-.07,0-.34.6-1.08,1.59-2.11a.05.05,0,0,1,0,0c2.62-2.75,8.15-7.52,14.58-12.84l3.9-3.1,26.57,33.45-3.95,3.45s6.7,27.13,6.67,30.45S308.88,439.26,306.83,437.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,437.9c-2.05-1.35-43-53.89-43.33-56.88-.13-1.13,7.18-7.55,16.23-15.06l.29-.23,26.82,33.6-.58.44s6.69,27.12,6.66,30.45S308.87,439.26,306.83,437.9Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83,437.9c-2.05-1.35-43-53.89-43.33-56.88-.13-1.13,7.18-7.55,16.23-15.06l.29-.23,26.82,33.6-.58.44s6.69,27.12,6.66,30.45S308.87,439.26,306.83,437.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.41,435.72c-6.7-9-34.54-44.8-41.84-53.22-.06-.06-.11,0-.06.05,6.44,9.09,34.57,44.63,41.75,53.28C308.41,436,308.55,435.91,308.41,435.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38,402.69c-2.07-4-5.93-7.83-10.49-8.56-.18,0-.22.22-.09.31A62.28,62.28,0,0,1,307.92,403,.29.29,0,0,0,308.38,402.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.82,406.39c-2.07-4-5.93-7.84-10.49-8.56-.17,0-.21.22-.09.31a61.93,61.93,0,0,1,10.13,8.58A.28.28,0,0,0,308.82,406.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,410.09c-2.07-4-5.93-7.84-10.49-8.56-.18,0-.21.22-.09.31a61.93,61.93,0,0,1,10.13,8.58A.28.28,0,0,0,309.27,410.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.71,364.26l29.66,35.39s67.19-60.76,69.53-70.09c2.66-10.61,19.26-86.69,19.29-90.87,0-5.07-2.19-25.48-2.19-25.48H355s-15.13,91.34-16.43,94.69C337.14,311.5,281.71,364.26,281.71,364.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.1,389.23c-3.94-5.94-20-25.81-22.17-27.62-.05,0-.15,0-.12.09,1.3,2.49,14.89,19.84,22.13,27.66C315,389.45,315.16,389.33,315.1,389.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.23,213.21l.23,96.32c-2.16,9-3.87,17.25-4.56,20-1.21,4.82-19.74,23.38-37.36,40.2L337,309.92a10.71,10.71,0,0,0,1.54-2c1.31-3.35,16.43-94.69,16.43-94.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.33,402.4s0,39.8,0,39.83c.16,8.33.44,15.64.94,19.4a.13.13,0,0,0,0,.06,5.66,5.66,0,0,0,.66,2.56s0,.05.05.06c2.51,1.63,69.15,2.35,71.48,1.59s.36-7.46-2.21-9.55-28-13.78-28-13.78l-1.71-39.67Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.46,465.9c-2.33.76-69,0-71.48-1.6,0,0,0,0-.05,0a5.73,5.73,0,0,1-.66-2.57s0,0,0-.06c-.5-3.76-.79-11.06-.94-19.4,0,0,0-2,0-5l42.73.09.23,5.24s25.38,11.69,28,13.78S418.8,465.15,416.46,465.9Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.46,465.9c-2.33.76-69,.05-71.48-1.59-1-.61-1.43-10.33-1.65-22.08,0-.12,0-.25,0-.37l43,0,0,.73s25.38,11.68,28,13.78S418.8,465.15,416.46,465.9Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.46,465.9c-2.33.76-69,.05-71.48-1.59-1-.61-1.43-10.33-1.65-22.08,0-.12,0-.25,0-.37l43,0,0,.73s25.38,11.68,28,13.78S418.8,465.15,416.46,465.9Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.74,463.31c-11.23-.4-56.56-.94-67.69-.47-.09,0-.09.06,0,.07,11.12.63,56.45.8,67.68.59C416,463.49,416,463.32,415.74,463.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.9,442.74c-4.41-.87-9.82-.25-13.23,2.86-.13.12,0,.31.18.26a62.75,62.75,0,0,1,13-2.56A.28.28,0,0,0,389.9,442.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.07,444.7c-4.41-.87-9.82-.25-13.23,2.86-.14.12,0,.31.18.26a62.1,62.1,0,0,1,13-2.56A.28.28,0,0,0,393.07,444.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.24,446.66c-4.41-.88-9.82-.26-13.23,2.86-.14.12,0,.3.18.26a62.12,62.12,0,0,1,13-2.57A.28.28,0,0,0,396.24,446.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.88,213.21s-.95,18.87-7.81,29.93c0,0-7.44,2.9-8.25,3.42,0,0,4.54,66.19,5.54,88.29C385.48,359.4,387.11,440,387.11,440l-45.25-.19s3.22-96.5,3-102.68c-.4-9.93-9.63-88.17-9.53-92.92.2-9.92,7.66-31,7.66-31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.51,430.14c-11.48-.63-33.71-.51-36.55,0-.07,0-.07.14,0,.15,2.85.54,29.86.75,36.56,0A.11.11,0,0,0,382.51,430.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.51,228.09c.83-.13,1.71,0,2.56-.06a19.55,19.55,0,0,0,2.65-.31,19,19,0,0,0,4.83-1.59,10.31,10.31,0,0,0,3.66-3.38c.53-.75,3-4.77,3-4.8s.27,0,.24.1c-.17.57-1.85,4.11-2.35,5a10,10,0,0,1-3.81,4,15.62,15.62,0,0,1-5.35,1.64,16.3,16.3,0,0,1-2.88.13,7.41,7.41,0,0,1-2.65-.44C352.3,228.29,352.39,228.11,352.51,228.09Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387,243.2a68.8,68.8,0,0,0-11.12,4.45c-.14.07-.06.29.09.23,3.74-1.37,7.55-2.66,11.2-4.24A.24.24,0,0,0,387,243.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.54,218.2c0-.13-.22-.17-.23,0A118.81,118.81,0,0,1,388,230.34c-.27,1.87-2.35,12.18-5.57,11.25-.54-.16-.79-.71-.83-1.54a13,13,0,0,1,.61-3.17c.48-2.15.89-4.32,1.19-6.51a59.57,59.57,0,0,0,.55-12.3.11.11,0,1,0-.21,0A113.11,113.11,0,0,1,381.84,235c-.55,2.68-2.14,6.68.67,7.25s5.09-6.14,5.54-8A61.9,61.9,0,0,0,389.54,218.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.53,241.87a17.69,17.69,0,0,0-.85,2.12,4.86,4.86,0,0,0-.41,1.75.13.13,0,0,0,.23.06,6,6,0,0,0,.85-1.68c.29-.65.58-1.3.85-2A.37.37,0,0,0,382.53,241.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.4,228.15a4.76,4.76,0,0,0-.82-.45,5.68,5.68,0,0,1-.86-.68,10.45,10.45,0,0,1-1.59-2.11,14.81,14.81,0,0,1-1.26-3.44c-.19-.72-1-4.47-1-4.5s-.19,0-.19.11a36.88,36.88,0,0,0,.74,4.59,14.56,14.56,0,0,0,1.47,3.87,7.44,7.44,0,0,0,1.76,2.23,3,3,0,0,0,.92.56c.28.1.59.23.84,0C398.47,228.35,398.44,228.18,398.4,228.15Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.31,155.68c11.12,22.72,23.56,43.86,32,44.52,1.47.11,9.58-.89,12.14-6.34,4.3-9.18,8.63-27.62,9.42-36.42.35-3.91-25.81-8.57-26.73-4.47-1.27,5.72-1.38,10.23-2,10.14-1-.14-6.7-7-16.86-15.68C370.33,135.45,372.63,148.15,376.31,155.68Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,147c-.81,5.48-6.87,16-9.31,18s-20.73-7.71-21.28-10.89,3.63-21.43,7.77-25.28S434.85,141.33,434,147Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.57,150.9a45.8,45.8,0,0,0-4.95-12.41c-2.84-4.53-7.57-10.92-5.19-12.54,4.88-3.32,16.66,12.63,16.66,12.63s4.07,7.88-.47,11.6A5.83,5.83,0,0,1,403.57,150.9Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.83 139.64 420.08 136.08 409.78 120.89 403.14 125.39 414.83 139.64",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.14 125.39 407.6 130.83 414.84 139.64 420.08 136.08 409.78 120.89 403.14 125.39",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "403.14 125.39 407.6 130.83 413.71 126.69 409.78 120.89 403.14 125.39",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.06,
    y: 118.33,
    width: 9.98,
    height: 7.58,
    transform: "translate(810.65 -4.69) rotate(145.86)",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.71 123.24 399.56 119.53 392.68 109.38 386.69 114.37 392.71 123.24",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.61 105.13 404.77 120.11 416.41 114.1 447.67 106.34 423.28 70.37 404.5 96.54 394.61 105.13",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 436.06,
    cy: 87.96,
    rx: 7.02,
    ry: 21.84,
    transform: "translate(25.78 259.88) rotate(-34.14)",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.39,90.67c6,8.86,13,14.6,15.64,12.82s-.11-10.41-6.12-19.27-13-14.6-15.64-12.82S425.38,81.81,431.39,90.67Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.17,90.15c.8,1.18,1.62,2.3,2.44,3.36a4.34,4.34,0,0,0,4-6.76l-1.15-1.7a4.34,4.34,0,0,0-6-1.16,4.45,4.45,0,0,0-1.71,2.3C430.44,87.49,431.27,88.82,432.17,90.15Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.53 124.88 412.77 117.71 399.46 98.08 387.9 107.73 399.53 124.88",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "399.53 124.88 412.77 117.71 399.46 98.08 387.9 107.73 399.53 124.88",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.27,74a13.56,13.56,0,0,0,.51,4.86,30.4,30.4,0,0,0,1.66,4.63c.31.76.69,1.48,1.05,2.22s.77,1.45,1.18,2.16.83,1.41,1.27,2.1.88,1.38,1.34,2.06a54.52,54.52,0,0,0,6.2,7.61,28.34,28.34,0,0,0,3.76,3.16,11.58,11.58,0,0,0,4.46,2,11.89,11.89,0,0,1-4.32-2.17,28,28,0,0,1-3.64-3.24,56.53,56.53,0,0,1-6.07-7.62,58.53,58.53,0,0,1-4.91-8.42A32,32,0,0,1,424,78.77,14,14,0,0,1,423.27,74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436,64.19c-.53,1-1,2-1.47,3.07s-.9,2.07-1.33,3.11-.85,2.1-1.23,3.17l-.57,1.59c-.18.54-.37,1.07-.53,1.62.27-.5.51-1,.76-1.52l.71-1.55c.47-1,.9-2.07,1.33-3.11s.84-2.1,1.23-3.16S435.67,65.28,436,64.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.77,97c1.26-.22,2.51-.48,3.75-.76s2.49-.58,3.72-.88,2.47-.65,3.69-1l1.84-.54c.6-.2,1.22-.38,1.82-.59-.63.1-1.26.23-1.88.35l-1.87.4c-1.25.27-2.49.58-3.72.89s-2.47.64-3.69,1S445,96.54,443.77,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.38,83.3c-1.77.63-3.52,1.31-5.26,2s-3.47,1.41-5.2,2.13-3.45,1.47-5.16,2.24l-2.56,1.16c-.84.4-1.7.79-2.54,1.21.89-.31,1.76-.66,2.64-1l2.62-1c1.74-.68,3.47-1.4,5.2-2.13s3.45-1.46,5.15-2.24S461.69,84.12,463.38,83.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.7,60.25c-1.05,1.6-2,3.22-3,4.84s-1.95,3.27-2.9,4.91-1.89,3.3-2.8,5l-1.36,2.5c-.44.85-.89,1.68-1.31,2.54.52-.8,1-1.61,1.53-2.41l1.48-2.43c1-1.63,1.95-3.27,2.9-4.91s1.89-3.3,2.8-5S444.84,62,445.7,60.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,85.75c1.86-1.16,3.7-2.37,5.52-3.59s3.63-2.47,5.44-3.7,3.6-2.52,5.38-3.8L458,72.73c.88-.66,1.77-1.31,2.64-2-.94.58-1.85,1.18-2.78,1.77l-2.74,1.82c-1.83,1.21-3.63,2.46-5.45,3.7s-3.59,2.51-5.37,3.8S440.76,84.41,439,85.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406,136.06c1.14,2.71,3.68-.18,3.68-.18s-2.66,5-.41,7.38,5.12-1.34,5.34-1.59c-.14.26-2.47,5,0,7.08s4.95-1.92,5.1-2.19c-.05.3-.67,4.19,1.6,5.37,3.9,2,5.74-7.89,8.76-9.78,0,0,3.78,4.74,3.91,4.86s1.95-9.41-.82-13.33a3.06,3.06,0,0,0-3.68-1.11s1-3-.95-4.69c-1-.89-3.28-.1-3.28-.1a3.85,3.85,0,0,0-1.13-3.84c-1.43-1.15-3.51-.18-3.51-.18s-.43-2.61-2.27-3.3C414.64,119,403.57,130.26,406,136.06Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.27,123.86s0-.09,0-.06A27.28,27.28,0,0,0,409.52,136c-.07.16.16.34.27.17A56.27,56.27,0,0,1,420.27,123.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.3,127.7c.05,0,0-.12-.07-.08a25.59,25.59,0,0,0-10.86,14.06c-.06.21.1.45.18.22C416,138,421.43,131,425.3,127.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.76,147c1.83-5.68,5.31-10.21,9.54-14.34.06-.06,0-.13-.08-.1-2.63,1.46-5.05,4.38-6.75,6.81a15.7,15.7,0,0,0-2.91,7.57C419.55,147.07,419.72,147.14,419.76,147Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.57,135.91c-.08.19.3.1.22.29-.31.84-1.75,6-.15,7,1.29.83,3.31-.32,3.9-1.07l1.51-1.88-.76,2.29a10,10,0,0,0-.53,3.14,3.54,3.54,0,0,0,1,2.7,2,2,0,0,0,2.52.24,6.05,6.05,0,0,0,2-2.3l1.35-2.52-.45,2.81a9.32,9.32,0,0,0-.08,2.36,3.76,3.76,0,0,0,.75,2.07,1.8,1.8,0,0,0,1.8.62,4,4,0,0,0,1.78-1.36,31.18,31.18,0,0,0,2.67-4.17c.42-.72.84-1.45,1.3-2.15a5.87,5.87,0,0,1,1.67-1.87,6.28,6.28,0,0,0-1.47,2c-.4.73-.76,1.48-1.12,2.23a27.2,27.2,0,0,1-2.51,4.4,4.64,4.64,0,0,1-2.08,1.7,2.56,2.56,0,0,1-2.7-.81,4.68,4.68,0,0,1-1-2.55,10.08,10.08,0,0,1,.05-2.63l.9.29a7,7,0,0,1-2.33,2.75,2.91,2.91,0,0,1-1.92.46,3.33,3.33,0,0,1-1.77-.84,4.44,4.44,0,0,1-1.29-3.41,10.63,10.63,0,0,1,.63-3.45l.75.41c-.79.92-2.9,2.46-5.06,1.43C406.55,142.35,409.05,136.88,409.57,135.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.67,135.88a5.92,5.92,0,0,1-1.58.87,1.37,1.37,0,0,1-1.36-.22,2.71,2.71,0,0,1-.69-1.42c-.13-.57-.24-1.19-.32-1.83a4.79,4.79,0,0,0-.32,1.92,2.76,2.76,0,0,0,.78,2,1.88,1.88,0,0,0,2.16.19A3.12,3.12,0,0,0,409.67,135.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,164.64,403.14,152s-1.83,10.31-2.2,10.36-9.24-10.51-19.71-17.77c-10.78-7.48-9.5,2.49-6,10.79,3.79,9.09,22.11,42.6,30.69,45.3,7.27,2.3,14.08-3.58,15.78-6.58C424,190,434,164.64,434,164.64Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.84,168.31c-1-.57-10.65-4.35-12.76-5.13l-6.34-2.32c-2.18-.8-4.37-1.72-6.61-2.34-.1,0-.16.11-.07.15,2.09,1,4.33,1.8,6.49,2.65l6.4,2.53c2.14.83,11.75,4.37,12.86,4.61C429.9,168.48,429.91,168.35,429.84,168.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,162.4c-.26,1.68-.41,3.36-.54,5s-.2,3.38-.23,5.07,0,3.38.08,5.07a42.76,42.76,0,0,0,.51,5c0-.84,0-1.69,0-2.53s0-1.69,0-2.53l.08-5.05.07-5.06,0-2.53C401,164.09,401,163.25,401,162.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.82,199.88a12.15,12.15,0,0,1-8.93.79c-8.58-2.71-26.9-36.21-30.69-45.29-2.69-6.46-4.07-13.91.5-13.42C383.36,153.22,403.15,182.59,414.82,199.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.85,223.73l62.46-3.63c.87-1-14.5-67.4-21.88-76.63-1.59-2-10.45-4.88-16.81.22C348.63,153.3,336.26,223.08,336.85,223.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.5,141.92s5.95,23,7.11,31,.58,73.82.58,73.82l-35.56,6.56s5.53-49.2,5.61-51c0,0,6.32-35.69,13.7-49.84C358.37,142.08,361.5,141.92,361.5,141.92Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.65,142.35s6,24.52,6.52,27.12S393,245.2,393,245.2l13.05,2.1-8.58-48.51S383.38,146.24,376.65,142.35Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.31,149.78c-11.06,13.37-23.82,34.46-25.8,43.48-1.39,6.32,8.41,34.47,12,41.52,1.56,3.05,25.31-6.15,24.59-9.73-.86-4.3-13.05-30.93-12.3-31.81s6.2-24.81,9.28-39.12C363.47,138.42,356.64,144.54,352.31,149.78Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,233.94l28.29-14.4s-11.9-22.67-11.94-24.49c-.07-2.93,6.35-28.22,8.61-39s1.95-21.42-11-5.14-24.42,37.54-25.63,43.91C323.49,199.27,336,233.94,336,233.94Z",
    style: {
      fill: "#419A5B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.76,225.92c.95-.67,4.94-2.71,5.87-3.19l6.09-3.2c2-1,4.06-2.11,6.1-3.14s4-2.12,6.11-3a.08.08,0,0,1,.07.14c-1.87,1.3-15.85,8.82-17.92,9.8-1,.47-5.15,2.4-6.27,2.72C334.75,226,334.7,226,334.76,225.92Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361,221.24l3.28-1.81-.06.17c-4.3-7.9-8.77-15.77-12.23-24.09a6.26,6.26,0,0,1,.21-2.48c1.95-9.57,4.31-19,6.89-28.41-.94,4.78-1.95,9.55-3,14.31-1.05,5.33-2.46,10.65-3.23,16,1.26,3.94,3.43,7.65,5.17,11.41.08.14,6.35,13.08,6.44,13.26l-.11.06-3.4,1.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.76,170.31a30.8,30.8,0,0,0,1.74-4.19,4.63,4.63,0,0,1-1.74,4.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.66,235.63c5.31.24,10.34-2.11,15.13-4.13,4.13-2,8.48-3.85,11.77-7.1a4.57,4.57,0,0,0,1.07-1.64,4.07,4.07,0,0,1-.86,1.8c-4.59,5.8-19.78,12.7-27.11,11.07Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.85,151c-3.21,1-10.33-2.26-13-6.74-.18-.31.16-3.65.39-7.72.12-2.48.2-5.23.1-7.75,0-.52,16,3.17,16,3.17a40.32,40.32,0,0,0-1.12,9.74,6.38,6.38,0,0,0,.15,1c0,.05,0,.1,0,.17C377.74,144.84,378.28,149.88,374.85,151Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.31,142.72c0,.05,0,.11,0,.17a9.8,9.8,0,0,1-1.61.15c-9.32.19-12.27-11.35-12.87-14.28,2.83.28,15.42,3.18,15.42,3.18a40.44,40.44,0,0,0-1.12,9.75A5.42,5.42,0,0,0,377.31,142.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,99.92s3.87,2.68,5.42,5.8.59,10,.59,10Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.53,109.28c-1.29,5.72,2.86,21.66,7.11,25,6.16,4.8,15.64,4.6,19.56-2.67,3.81-7-2-27.73-6.66-30.67C371.63,96.57,360.44,100.82,358.53,109.28Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.16,118.26s-.08.07-.06.12c.31,1.06.48,2.34-.4,2.94,0,0,0,.07,0,.06C373.87,120.91,373.62,119.22,373.16,118.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.91,117.38c-1.76.31-1,3.82.62,3.53S373.39,117.12,371.91,117.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.54,116.84s.1,0,.11.08c.2,1.09.61,2.31,1.67,2.46a0,0,0,0,1,0,.07C380.09,119.53,379.56,117.91,379.54,116.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.27,115.5c1.72-.5,2.6,3,1,3.44S378.83,115.93,380.27,115.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.18,116.08c.45-.22.83-.51,1.26-.77s.89-.49,1.13-1a.76.76,0,0,0-.31-.87,1.89,1.89,0,0,0-1.9.21,2.7,2.7,0,0,0-1.3,1.5A.81.81,0,0,0,370.18,116.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.25,113.45c-.51,0-1,0-1.47-.06a2.4,2.4,0,0,1-1.49-.35.77.77,0,0,1-.15-.92,1.89,1.89,0,0,1,1.76-.73,2.75,2.75,0,0,1,1.86.67A.81.81,0,0,1,381.25,113.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.44,128.22c.32.2.65.5,1.05.44a2.76,2.76,0,0,0,1.11-.52s.08,0,.06.05a1.5,1.5,0,0,1-1.25.88,1.18,1.18,0,0,1-1.06-.78S374.4,128.19,374.44,128.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.89,124.73a3.83,3.83,0,0,0,2.82,1.12,4.77,4.77,0,0,0,1.34-.23l.25-.08.23-.09a.27.27,0,0,0,.16-.29h0l0-.11h0l0-.1c-.15-.84-.51-2.09-.51-2.09.34.08,2.05.45,1.93,0A57,57,0,0,0,377.22,112c-.05-.11-.23,0-.19.07.81,3.47,2.23,6.77,3.11,10.24a6.82,6.82,0,0,0-1.86-.16c-.11.06.73,2.41.77,2.8v0a5.24,5.24,0,0,1-4.08-.37C374.87,124.57,374.8,124.66,374.89,124.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.47,125.3A4.51,4.51,0,0,1,377,127a2,2,0,0,1-1.18.33c-.92,0-1.11-.83-1.09-1.55a4.47,4.47,0,0,1,.16-1.12A5.83,5.83,0,0,0,378.47,125.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,127a2,2,0,0,1-1.18.33c-.92,0-1.11-.83-1.09-1.55A2.08,2.08,0,0,1,377,127Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.68,123c3-.54,1.87-5.76,1.87-5.76s5.84-2.07,5-10c0,0,9.28,1.36,12.92-4s-10.46-14.21-22.36-1c0,0-6.37,2.4-6.35,8S357,123.65,360.68,123Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.15,106.44c0-.07-.17,0-.13.07,2,5-.44,10.29-6,11a.15.15,0,0,0,0,.29C366.64,117.65,370.63,111.25,367.15,106.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.09,95.39s0,0,0,0a19.15,19.15,0,0,1,5.7.34c2.78.72,6.72,3.21,5.52,6.64-1.65,4.71-8.27,4.78-12.38,4.52a.21.21,0,0,0-.08.42c4.28,1,12.57-.07,13.24-5.58C382.85,95.65,374.18,94.72,370.09,95.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.61,122.33s-4.14-4.87-6.39-3.35,1.22,8.83,4.09,9.6A2.85,2.85,0,0,0,365,126.7Z",
    style: {
      fill: "#eb9481"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.27,121.05s0,.06,0,.08c2,.6,3.22,2.31,4.11,4.12A1.56,1.56,0,0,0,360,125c-.05,0,0,.12.06.1a1.74,1.74,0,0,1,2,.43A8.18,8.18,0,0,1,363.1,127c.1.16.41,0,.32-.15l0,0C363.22,124.34,361,121.05,358.27,121.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.18,141.5l-3.76,9.19L362.05,139l-3.28,3.72s11.08,18.6,11.15,17.77l3.86-7.92,5.44,5.56-.35-13.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.44,151.22c-.14-2.29-.21-4.6-.45-6.88,0-.09-.13-.12-.15,0-.48,2.21.08,11,.06,13.06l0,0c-.22-.24-5-4.89-5.09-4.82-.84,1.26-3.66,7-3.86,7.55-1.75-3-9.19-14.61-11.26-17.41a.08.08,0,0,0-.14.08c1.54,3.12,11.15,18.49,11.29,18.45a90.44,90.44,0,0,0,4-8.37c.81,1,5.67,6.27,5.69,5.93A72.72,72.72,0,0,0,379.44,151.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "371.69 157.13 373.89 152.68 377.53 156.15 376.53 159.36 373.15 159.64 371.69 157.13",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.15 159.64 372.12 197.94 379.43 211.25 384.16 197.66 376.53 159.36 373.15 159.64",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPost);
export default __webpack_public_path__ + "static/media/jobPost.ca4192e324ef432b5fe8b133f99d5150.svg";
export { ForwardRef as ReactComponent };